import React, { Component } from 'react';
import { pick } from 'lodash';
import classNames from 'classnames';
import Select from 'components/shared/select';
import FileStackImage from 'misc/filestack_image';
import { ImageTypes } from 'constants/imageTypes';
import CertificationCardPreview from './CertificationCardPreview';
import TopicCardPreview from './TopicCardPreview';
import LessonCardPreview from './LessonCardPreview';
import PathCardPreview from './PathCardPreview';

const IMAGE_MODE = 'image';
const TOPIC_CARD_MODE = 'topic';
const LESSON_CARD_MODE = 'lesson';
const PATH_CARD_MODE = 'path';
const CERTIFICATION_CARD_MODE = 'certification';

class ImagePreviewCanvas extends Component {
  constructor(props) {
    super(props);
    this.state = {
      mode: IMAGE_MODE,
    };
    this.image = props.image?.bss_upload_id
      ? {
          ...props.image,
          url: props.image.bss_signed_url,
          name: props.image.file_name,
        }
      : this.setFileStackImage(props.image);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const {
      handle: nextHandle,
      bss_upload_id: nextBssUploadId,
      bss_signed_url: nextBssSignedUrl,
      file_name: nextFileName,
    } = nextProps.image;

    const { handle: currentHandle, bss_upload_id: currentBssUploadId } =
      this.props.image;

    if (nextBssUploadId && nextBssUploadId !== currentBssUploadId) {
      this.image = {
        ...nextProps.image,
        url: nextBssSignedUrl,
        name: nextFileName,
      };
    } else if (nextHandle && nextHandle !== currentHandle) {
      const { image } = nextProps;
      if (this.image instanceof FileStackImage) {
        this.image.updateParams(image);
      } else {
        this.image = this.setFileStackImage(image);
      }
    }
  }

  setFileStackImage(image) {
    return new FileStackImage({
      ...pick(image, ['signature', 'policy', 'handle']),
      transform: {
        resize: { width: 500, height: 300, fit: 'max' },
      },
    });
  }

  setMode(mode) {
    this.setState({ mode });
  }

  render() {
    const { mode } = this.state;
    const { image, imageType, isCertification } = this.props;
    const className = classNames('ImagePreviewCanvas', {
      'ImagePreviewCanvas--transparent': mode === IMAGE_MODE,
    });
    return (
      <div className={className}>
        {imageType === ImageTypes.COVER_IMAGE_TYPE && (
          <div className="ImagePreviewCanvas-header">
            <Select
              value={mode}
              icon="preview"
              onChange={e => this.setMode(e.target.value)}
              className="ImagePreviewCanvas-modePicker"
            >
              <option value={IMAGE_MODE}>Original Image</option>
              <option value={TOPIC_CARD_MODE}>Topic Card</option>
              <option value={LESSON_CARD_MODE}>Lesson Card</option>
              <option value={PATH_CARD_MODE}>Path Card</option>
              {isCertification && (
                <option value={CERTIFICATION_CARD_MODE}>
                  {t(
                    'certifications.certification_builder.sidebar.cover_image_preview_option',
                  )}
                </option>
              )}
            </Select>
          </div>
        )}
        <div className="ImagePreviewCanvas-previewArea">
          {mode === IMAGE_MODE && <img src={this.image.url} alt={image.name} />}
          {mode === TOPIC_CARD_MODE && <TopicCardPreview image={image} />}
          {mode === LESSON_CARD_MODE && <LessonCardPreview image={image} />}
          {mode === PATH_CARD_MODE && <PathCardPreview image={image} />}
          {isCertification && mode === CERTIFICATION_CARD_MODE && (
            <CertificationCardPreview image={image} />
          )}
        </div>
      </div>
    );
  }
}

export default ImagePreviewCanvas;
